import { render } from "./user-page.vue?vue&type=template&id=0742e123&ts=true"
import script from "./user-page.vue?vue&type=script&lang=ts"
export * from "./user-page.vue?vue&type=script&lang=ts"

import "./user-page.vue?vue&type=style&index=0&id=0742e123&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__